<template>
  <el-container class="layout">
    <el-header> <Header /> </el-header>
    <el-container class="layout-container">
      <el-aside style="width: 198px">
        <Menu />
      </el-aside>
      <el-main>
        <keep-alive exclude="Patent,Flow">
          <router-view />
        </keep-alive>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import Header from "@/components/Header";
import Menu from "./components/Menu";
export default {
  components: {
    Header,
    Menu
  }
};
</script>
<style lang="less" scoped>
.layout-container {
  width: 96%;
  margin: 0 auto;
}
.el-aside {
  min-height: 100%;
  padding: 24px 18px 0 18px;
  text-align: center;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 10px 0px rgba(10, 3, 5, 0.26);
  border-radius: 13px;
  margin: 20px;
}
</style>
